import type { NavItem } from "../../data/site";
import type { ThemeMode } from "../../hooks/useTheme";
import { scrollToId } from "../../utils/scroll";
import "./navbar.css";

export function Navbar({
  brand,
  items,
  activeId,
  mobileOpen,
  onToggleMobile,
  onCloseMobile,
  theme,
  onToggleTheme
}: {
  brand: string;
  items: NavItem[];
  activeId: NavItem["id"];
  mobileOpen: boolean;
  onToggleMobile: () => void;
  onCloseMobile: () => void;
  theme: ThemeMode;
  onToggleTheme: () => void;
}) {
  return (
    <>
      <header className="nav">
        <div className="nav__inner">
          <button
            className="nav__brand"
            onClick={() => scrollToId("home")}
            aria-label="回到首页"
          >
            {brand}
          </button>

          <nav className="nav__links" aria-label="导航">
            {items.map((it) => (
              <button
                key={it.id}
                className={["nav__link", activeId === it.id ? "is-active" : ""].join(" ")}
                onClick={() => scrollToId(it.id)}
              >
                {it.label}
              </button>
            ))}
          </nav>

          <div className="nav__actions">
            <button className="iconbtn" onClick={onToggleTheme} aria-label="切换深浅色主题">
              {theme === "dark" ? (
                <span className="iconbtn__icon" aria-hidden>
                  ☾
                </span>
              ) : (
                <span className="iconbtn__icon" aria-hidden>
                  ◐
                </span>
              )}
            </button>

            <button
              className={["iconbtn nav__burger", mobileOpen ? "is-open" : ""].join(" ")}
              onClick={onToggleMobile}
              aria-label="打开菜单"
              aria-expanded={mobileOpen}
            >
              <span className="burger" aria-hidden>
                <span />
                <span />
              </span>
            </button>
          </div>
        </div>
      </header>

      <div
        className={["navsheet", mobileOpen ? "is-open" : ""].join(" ")}
        role="dialog"
        aria-label="移动端导航"
      >
        <div className="navsheet__panel">
          <div className="navsheet__top">
            <div className="navsheet__brand">{brand}</div>
            <button className="iconbtn" onClick={onCloseMobile} aria-label="关闭菜单">
              <span className="iconbtn__icon" aria-hidden>
                ✕
              </span>
            </button>
          </div>
          <div className="navsheet__links">
            {items.map((it) => (
              <button
                key={it.id}
                className={["navsheet__link", activeId === it.id ? "is-active" : ""].join(" ")}
                onClick={() => {
                  scrollToId(it.id);
                  onCloseMobile();
                }}
              >
                {it.label}
              </button>
            ))}
          </div>
          <div className="navsheet__hint">提示：主题会自动记住（本地存储）。</div>
        </div>
        <button className="navsheet__backdrop" onClick={onCloseMobile} aria-label="关闭" />
      </div>
    </>
  );
}

